module.exports = __webpack_public_path__ + "static/home-museum-8ea84700a202fb040aa5c8cf4cf19ee4.png";